// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
export default function CtaSection() {
  return (
    <section className="section">
      <div className="content">
        <div className="w-layout-grid grid-banner">
          <div id="w-node-fa5a991c-5956-883f-ada3-90790b0053f4-0b0053f1" className="block-banner">
            <div className="subtitle white">
              Are you ready to partner with us?
              <br />
            </div>
            <h2 className="heading banner">Your Next Adventure Begins Here</h2>
            <a data-w-id="fa5a991c-5956-883f-ada3-90790b0053fa" href="/contact" className="button yellow w-button">Contact us</a>
          </div>
          <div id="w-node-fa5a991c-5956-883f-ada3-90790b0053fc-0b0053f1" data-w-id="fa5a991c-5956-883f-ada3-90790b0053fc" className="lottie-banner">
            <div className="lines-d1">
              <div className="line-banner-w" />
              <div className="line-banner-w" />
              <div className="line-banner-w" />
              <div className="line-banner-w" />
              <div className="line-banner-w" />
              <div className="line-banner-w" />
            </div>
            <div className="lines-d2">
              <div className="line-banner-h" />
              <div className="line-banner-h" />
              <div className="line-banner-h" />
              <div className="line-banner-h" />
              <div className="line-banner-h" />
              <div className="line-banner-h" />
            </div>
            <div className="block-lottie-banner">
              <div data-w-id="fa5a991c-5956-883f-ada3-90790b00540c" data-is-ix2-target="1" className="lottie-animation-1-banner" data-animation-type="lottie" data-src="/assets/cdn/655c5d4d25d668c29fb0f204_Lottie%20B1%20White.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-loading="eager" />
              <div data-is-ix2-target="1" className="lottie-animation-2-banner" data-w-id="fa5a991c-5956-883f-ada3-90790b00540d" data-animation-type="lottie" data-src="/assets/cdn/655c5d4d25d668c29fb0f204_Lottie%20B1%20White.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-loading="eager" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
